export const SEARCH_RESULT_MIN_SIZE = 3;

export const UNVERIFIED = 'UNVERIFIED';
export const VERIFYING = 'VERIFYING';
export const VERIFIED = 'VERIFIED';
